import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RampBillFieldsFragment = { __typename?: 'RampBillData', rampBillId: string, invoiceNumber?: string | null, issuedAt?: Types.TDateISO | null, amount: number, currencyCode: string, displayStatus: Types.RampBillDisplayStatus, paidAt?: Types.TDateISO | null, paymentDate?: Types.TDateISO | null, rampUrl?: string | null, lastSyncedAt: Types.TDateISO };

export type RampPurchaseOrderInvoicesFieldsFragment = { __typename?: 'RampPurchaseOrderInvoicesData', vendorId: string, vendorLinkedToRamp: boolean, connectionStatus: Types.RampConnectionStatus, receivedValue: number, hasUncostedReceivedLines: boolean, invoicedTotal: number, paidTotal: number, invoiceStatus: Types.RampPurchaseOrderInvoiceStatus, invoices: Array<{ __typename?: 'RampLinkedInvoiceData', linkSource: Types.RampBillLinkSource, bill: { __typename?: 'RampBillData', rampBillId: string, invoiceNumber?: string | null, issuedAt?: Types.TDateISO | null, amount: number, currencyCode: string, displayStatus: Types.RampBillDisplayStatus, paidAt?: Types.TDateISO | null, paymentDate?: Types.TDateISO | null, rampUrl?: string | null, lastSyncedAt: Types.TDateISO } }> };

export type GetRampPurchaseOrderInvoicesQueryVariables = Types.Exact<{
  purchaseOrderId: Types.Scalars['String']['input'];
}>;


export type GetRampPurchaseOrderInvoicesQuery = { __typename?: 'Query', rampPurchaseOrderInvoices?: { __typename?: 'RampPurchaseOrderInvoicesData', vendorId: string, vendorLinkedToRamp: boolean, connectionStatus: Types.RampConnectionStatus, receivedValue: number, hasUncostedReceivedLines: boolean, invoicedTotal: number, paidTotal: number, invoiceStatus: Types.RampPurchaseOrderInvoiceStatus, invoices: Array<{ __typename?: 'RampLinkedInvoiceData', linkSource: Types.RampBillLinkSource, bill: { __typename?: 'RampBillData', rampBillId: string, invoiceNumber?: string | null, issuedAt?: Types.TDateISO | null, amount: number, currencyCode: string, displayStatus: Types.RampBillDisplayStatus, paidAt?: Types.TDateISO | null, paymentDate?: Types.TDateISO | null, rampUrl?: string | null, lastSyncedAt: Types.TDateISO } }> } | null };

export type GetUnlinkedRampBillsForPurchaseOrderQueryVariables = Types.Exact<{
  purchaseOrderId: Types.Scalars['String']['input'];
}>;


export type GetUnlinkedRampBillsForPurchaseOrderQuery = { __typename?: 'Query', unlinkedRampBillsForPurchaseOrder: Array<{ __typename?: 'RampBillData', rampBillId: string, invoiceNumber?: string | null, issuedAt?: Types.TDateISO | null, amount: number, currencyCode: string, displayStatus: Types.RampBillDisplayStatus, paidAt?: Types.TDateISO | null, paymentDate?: Types.TDateISO | null, rampUrl?: string | null, lastSyncedAt: Types.TDateISO }> };

export const RampBillFieldsFragmentDoc = new TypedDocumentString(`
    fragment RampBillFields on RampBillData {
  rampBillId
  invoiceNumber
  issuedAt
  amount
  currencyCode
  displayStatus
  paidAt
  paymentDate
  rampUrl
  lastSyncedAt
}
    `, {"fragmentName":"RampBillFields"});
export const RampPurchaseOrderInvoicesFieldsFragmentDoc = new TypedDocumentString(`
    fragment RampPurchaseOrderInvoicesFields on RampPurchaseOrderInvoicesData {
  vendorId
  vendorLinkedToRamp
  connectionStatus
  receivedValue
  hasUncostedReceivedLines
  invoicedTotal
  paidTotal
  invoiceStatus
  invoices {
    linkSource
    bill {
      ...RampBillFields
    }
  }
}
    fragment RampBillFields on RampBillData {
  rampBillId
  invoiceNumber
  issuedAt
  amount
  currencyCode
  displayStatus
  paidAt
  paymentDate
  rampUrl
  lastSyncedAt
}`, {"fragmentName":"RampPurchaseOrderInvoicesFields"});
export const GetRampPurchaseOrderInvoicesDocument = new TypedDocumentString(`
    query GetRampPurchaseOrderInvoices($purchaseOrderId: String!) {
  rampPurchaseOrderInvoices(purchaseOrderId: $purchaseOrderId) {
    ...RampPurchaseOrderInvoicesFields
  }
}
    fragment RampBillFields on RampBillData {
  rampBillId
  invoiceNumber
  issuedAt
  amount
  currencyCode
  displayStatus
  paidAt
  paymentDate
  rampUrl
  lastSyncedAt
}
fragment RampPurchaseOrderInvoicesFields on RampPurchaseOrderInvoicesData {
  vendorId
  vendorLinkedToRamp
  connectionStatus
  receivedValue
  hasUncostedReceivedLines
  invoicedTotal
  paidTotal
  invoiceStatus
  invoices {
    linkSource
    bill {
      ...RampBillFields
    }
  }
}`);
export const GetUnlinkedRampBillsForPurchaseOrderDocument = new TypedDocumentString(`
    query GetUnlinkedRampBillsForPurchaseOrder($purchaseOrderId: String!) {
  unlinkedRampBillsForPurchaseOrder(purchaseOrderId: $purchaseOrderId) {
    ...RampBillFields
  }
}
    fragment RampBillFields on RampBillData {
  rampBillId
  invoiceNumber
  issuedAt
  amount
  currencyCode
  displayStatus
  paidAt
  paymentDate
  rampUrl
  lastSyncedAt
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetRampPurchaseOrderInvoices: build.query<GetRampPurchaseOrderInvoicesQuery, GetRampPurchaseOrderInvoicesQueryVariables>({
      query: (variables) => ({ document: GetRampPurchaseOrderInvoicesDocument, variables })
    }),
    GetUnlinkedRampBillsForPurchaseOrder: build.query<GetUnlinkedRampBillsForPurchaseOrderQuery, GetUnlinkedRampBillsForPurchaseOrderQueryVariables>({
      query: (variables) => ({ document: GetUnlinkedRampBillsForPurchaseOrderDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetRampPurchaseOrderInvoicesQuery, useLazyGetRampPurchaseOrderInvoicesQuery, useGetUnlinkedRampBillsForPurchaseOrderQuery, useLazyGetUnlinkedRampBillsForPurchaseOrderQuery } = injectedRtkApi;
